import { SafeSessionStorage } from '#pplx/frontend/browser-storage/sessionStorage.js';
import { getCookie, setCookie } from '#pplx/frontend/cookies/provider.js';
const STORAGE_KEY = 'eppo_overrides';
export const COOKIE_KEY = 'eppo_overrides';
const isPerplexityUser = (email) => {
    if (!email) {
        return false;
    }
    const isPerplexity = email.endsWith('@perplexity.ai');
    return isPerplexity;
};
export const readEppoParameters = (email, searchParams, isProduction) => {
    if (isProduction && !isPerplexityUser(email))
        return {};
    const overrides = {};
    searchParams.forEach((value, key) => {
        if (key.startsWith('eppo_')) {
            const flag = key.replace('eppo_', '');
            overrides[flag] = value ?? '';
        }
    });
    return overrides;
};
const saveToSessionStorage = (overrides) => {
    let success = true;
    const value = JSON.stringify(overrides);
    // Save to cookie (works in both client and server)
    try {
        setCookie(COOKIE_KEY, value);
    }
    catch (_cookieError) {
        success = false;
    }
    // Save to sessionStorage (client-only)
    success = SafeSessionStorage.setItem(STORAGE_KEY, value);
    return success;
};
// Main function to process URL parameters
export const processEppoParameters = (email, searchParams, isProduction) => {
    if (typeof window === 'undefined') {
        return false;
    }
    const overrides = readEppoParameters(email, searchParams, isProduction);
    if (Object.keys(overrides).length === 0) {
        return false;
    }
    const success = saveToSessionStorage(overrides);
    return success;
};
// Unlike URL-param overrides, pinned overrides must survive app restarts, so
// the cookie gets an explicit expiry instead of being session-scoped.
const PINNED_OVERRIDE_EXPIRES_DAYS = 365;
export function setEppoOverride(flag, value) {
    const serialized = JSON.stringify({ ...getEppoOverrides(), [flag]: value });
    try {
        setCookie(COOKIE_KEY, serialized, { expires: PINNED_OVERRIDE_EXPIRES_DAYS });
    }
    catch {
        return false;
    }
    return SafeSessionStorage.setItem(STORAGE_KEY, serialized);
}
export function getEppoOverrides() {
    try {
        // Try to get from cookie first (works in both client and server)
        const cookieValue = getCookie(COOKIE_KEY);
        if (cookieValue) {
            return JSON.parse(cookieValue);
        }
        // Fallback to sessionStorage (client-only)
        const stored = SafeSessionStorage.getItem(STORAGE_KEY);
        if (stored) {
            return JSON.parse(stored);
        }
        return {};
    }
    catch {
        return {};
    }
}
//# sourceMappingURL=storage.js.map